import { type Action, combineReducers, configureStore, type Middleware, type ThunkDispatch } from "@reduxjs/toolkit";
import { type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { persistReducer, persistStore } from "redux-persist";
import { authSlice } from "@/src/auth/store/auth.slice";
import { env } from "@/src/common/constants/env";
import { generalPersistConfig, generalSlice } from "@/src/common/store/general-slice";

const combinedReducers = combineReducers({
	[generalSlice.name]: persistReducer(generalPersistConfig, generalSlice.reducer),
	[authSlice.name]: authSlice.reducer,
});

export const store = configureStore({
	reducer: combinedReducers,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
	devTools: env.MODE !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppMiddlewareDispatch = ThunkDispatch<RootState, undefined, Action>;
export type AppMiddleware = Middleware<object, RootState, AppMiddlewareDispatch>;
